const env = import.meta.env;
const siteUrl = (env.VITE_SITE_URL || "https://example.com").replace(/\/$/, "");

export const siteConfig = {
  name: "마이리틀클래식",
  siteUrl,
  contact: {
    phone: env.VITE_CONTACT_PHONE || "CONTACT_PHONE",
    email: env.VITE_CONTACT_EMAIL || "CONTACT_EMAIL",
    kakao: env.VITE_KAKAO_URL || "KAKAO_URL",
    address: env.VITE_VENUE_ADDRESS || "VENUE_ADDRESS",
    // 네이버 스마트플레이스 — 지역 검색에서 사이트와 같은 업체임을 알리는 연결고리
    naverPlace: env.VITE_NAVER_PLACE_URL || "",
    businessInfo: env.VITE_BUSINESS_INFO || "BUSINESS_INFO",
  },
  formEndpoint: env.VITE_FORM_ENDPOINT || "",
};
